interface BuildUnavailableWarningMessagesParams {
	template: string;
	hasUrlParam: boolean;
	missingProductsCount: number;
	replacedProductsCount: number;
	staleSelectionsCount: number;
}

export function buildUnavailableWarningMessages({
	template,
	hasUrlParam,
	missingProductsCount,
	replacedProductsCount,
	staleSelectionsCount,
}: BuildUnavailableWarningMessagesParams): string[] {
	const counts: number[] = [];

	if (missingProductsCount > 0) {
		counts.push(missingProductsCount);
	}

	if (!hasUrlParam && replacedProductsCount > 0) {
		counts.push(replacedProductsCount);
	}

	if (staleSelectionsCount > 0) {
		counts.push(staleSelectionsCount);
	}

	return counts.map((count) => template.replace("{COUNT}", String(count)));
}
